import Table from "@bmi-digital/components/table";
import { replaceSpaces } from "@bmi-digital/components/utils";
import React from "react";
import {
  DesktopTableWrapper,
  FeatureValue,
  StyledTableCell,
  MobileTable,
  MobileTableFeatureGroup,
  MobileTableFeatureRow,
  MobileTableRow,
  MobileTableRowHeader,
  MobileTableFeatureName
} from "./styles/ProductFeaturesTableStyles";
import type { Product } from "../types/pim";

export type FeatureTableProps = {
  classifications: Product["classifications"];
};

const DesktopFeaturesTable = ({ classifications }: FeatureTableProps) => {
  return (
    <DesktopTableWrapper className="desktop-table">
      {classifications.map(({ features, name: heading }) => (
        <Table
          hasNoBorder={false}
          rowBgColorPattern="none"
          key={`desktop-table-${heading}`}
        >
          <Table.Head>
            <Table.Row>
              <StyledTableCell data-testid="classification-name">
                {heading}
              </StyledTableCell>
              <StyledTableCell />
            </Table.Row>
          </Table.Head>
          <Table.Body>
            {features.map(({ name, values }, index) => (
              <Table.Row
                key={`feat-row-${name}--${index}`}
                data-testid="classification-feature"
              >
                <StyledTableCell
                  align="left"
                  data-testid="classification-feature-name"
                >
                  {name}
                </StyledTableCell>
                <StyledTableCell align="right">
                  {values.map((value) => (
                    <FeatureValue
                      variant="body1"
                      data-testid="classification-feature-value"
                      key={replaceSpaces(`${name}-${value}`)}
                    >
                      {value}
                    </FeatureValue>
                  ))}
                </StyledTableCell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      ))}
    </DesktopTableWrapper>
  );
};

const MobileFeaturesTable = ({ classifications }: FeatureTableProps) => {
  return (
    <MobileTable role="table" data-testid="table" className="mobile-table">
      {classifications.map(({ features, name: heading }, index) => (
        <MobileTableRow
          role="row"
          key={`Mobile-row-${index}`}
          data-testid="document-table-row"
        >
          <MobileTableRowHeader
            role="rowheader"
            data-testid="classification-name"
          >
            <span>{heading}</span>
          </MobileTableRowHeader>
          <MobileTableFeatureGroup>
            {features.map(({ name, values }) => (
              <MobileTableFeatureRow
                key={`Mobile-feature-row-${index}`}
                data-testid="classification-feature"
              >
                <MobileTableFeatureName
                  role="cell"
                  variant="body1"
                  data-testid="classification-feature-name"
                >
                  {name}
                </MobileTableFeatureName>
                {values.map((value) => (
                  <FeatureValue
                    role="cell"
                    variant="body1"
                    data-testid="classification-feature-value"
                    key={`Mobile-cell-${index}`}
                  >
                    {value}
                  </FeatureValue>
                ))}
              </MobileTableFeatureRow>
            ))}
          </MobileTableFeatureGroup>
        </MobileTableRow>
      ))}
    </MobileTable>
  );
};

const ProductFeaturesTable = ({ classifications }: FeatureTableProps) => {
  return (
    <>
      <DesktopFeaturesTable classifications={classifications} />
      <MobileFeaturesTable classifications={classifications} />
    </>
  );
};

export default ProductFeaturesTable;
